import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import { RecruitmentEntryButtonProps as Props, RecruitmentEntryButtonState } from './types';
import { fetchRecruitmentEntryButton } from '../../../services/recruitments';

export const Component: FunctionComponent<Props> = (props) => {
  const [state, setState] = useState<RecruitmentEntryButtonState>({
    isInitialized: false,
    isStopped: false,
    isNotLoggedIn: false,
    isScouted: false,
    attentionPeople: 0,
  });

  useEffect(() => {
    const request = async () => {
      try {
        const response = await fetchRecruitmentEntryButton(props.recruitmentId);
        setState({ ...response, isInitialized: true });
      } catch (error) {
        console.log(error);
      }
    };
    request();
  }, [props.recruitmentId]);

  useEffect(() => {
    if (state.isInitialized) {
      const $firstButton = $('.recruitment-entry-button-first');
      const $bottomButton = $('.recruitment-entry-button-bottom');
      if ($firstButton.length) {
        $bottomButton.hide();
        $(window).on('scroll', () => {
          const buttonTop = $firstButton.offset()?.top || 0;
          const scrollTop = $(window).scrollTop() || 0;;
          if (buttonTop < scrollTop) {
            $bottomButton.show();
          } else {
            $bottomButton.hide();
          }
        });
      }
    }
  }, [state.isInitialized]);

  return (
    <Presentation
      {...props}
      state={state}
      handleClickEntry={props.handleClickEntry}
      handlePreviewClick={props.handlePreviewClick}
    />
  );
};
